@if (hasTitle()) {
    <div class="label" [@fade]>
        <div class="label-title" id="page-header-context-label">
            {{ title }}
        </div>
    </div>
}
@if (hasDescription()) {
    <div class="description" [@fade]>
        <div class="description-title" id="page-header-context-description">
            {{ description }}
        </div>
    </div>
}
